module.exports = "/static/assets/a213a0b297d31a50e37d52eb96831d40.png";